import crudTemplate from "../../../templates/crudTemplate";
import rolesTemplate from "../../../templates/rolesTemplate";
import ExportLink from "../../../utils/services/project/accounting/exportLinkService";
let crud = crudTemplate(ExportLink);
let roles = rolesTemplate(ExportLink);
function prepareItem(item) {
  if (item._target_type) {
    item.target_type_id = item._target_type.id;
    item.target_type = item._target_type.target_name;
    item.interface = item._target_type.interface;
  }
  return item;
}
const state = {
  ...crud.state,
  ...roles.state
};
const getters = {
  ...crud.getters,
  ...roles.getters,
  getList(state) {
    return crud.getters.getList(state).map(prepareItem);
  }
};

const actions = {
  ...crud.actions,
  ...roles.actions,
  create(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item._target_type = { id: item.target_type_id };
    item._cost_centre = { id: item.cost_centre_id };
    return crud.actions.create(_, {
      item,
      errorHandler,
      onSuccess
    });
  },
  update(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item._cost_centre = { id: item.cost_centre_id };
    item._contact = { id: item.contact_id };
    return crud.actions.update(_, {
      item,
      errorHandler,
      onSuccess
    });
  }
};

const mutations = {
  ...crud.mutations,
  ...roles.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
